export default __webpack_public_path__ + "static/treeWhatis-518e22e08baa2c9432044ca0dea021d7.png";